import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignDescubrirProps {
  sign: Sign;
}
export function SignDescubrir({
  sign
}: SignDescubrirProps) {
  const items = sign.content.descubriras;
  return <section className="py-20 px-6 bg-cosmic-black" data-id="element-286">
      <div className="container mx-auto max-w-5xl" data-id="element-287">
        <AnimatedSection data-id="element-288">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-289">
            Qué Descubrirás
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-290">
          {items.map((item, index) => <AnimatedSection key={index} delay={0.15 + index * 0.08} data-id="element-291">
              <GlowCard glowColor={sign.colors.primary} className="h-full flex items-center" data-id="element-292">
                <div className="flex items-start" data-id="element-293">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mr-4" style={{
                backgroundColor: `${sign.colors.primary}25`,
                border: `2px solid ${sign.colors.primary}`,
                boxShadow: `0 0 15px ${sign.colors.primary}40`
              }} data-id="element-294">
                    <span style={{
                  color: sign.colors.accent
                }} className="font-bold font-serif" data-id="element-295">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-gray-200 leading-relaxed pt-1" data-id="element-296">{item}</p>
                </div>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}